import React from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import './DashboardLayout.css';

const DashboardLayout = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/dashboard/block-management');
  };

  return (
    <div className="dashboard-container">
      <aside className="dashboard-sidebar">
        <div 
          className="sidebar-brand"
          onClick={handleLogoClick}
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <img 
            src="/black_icon_only.png" 
            alt="Block Logo" 
            className="sidebar-logo"
          />
          <span>block automation</span>
        </div>
        <nav className="sidebar-nav">
          <Link to="/dashboard/block-management" className="sidebar-link">Block Management</Link>
          <Link to="/dashboard/settings" className="sidebar-link">Settings</Link>
        </nav>
      </aside>
      <main className="dashboard-main">
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;